module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-subscriptions/view-subscriptions.component.css
// module id = ./src/app/view-subscriptions/view-subscriptions.component.css
// module chunks = main